const countTotalSize = <T extends { size: number }>(files: T[]) =>
  files.reduce((acc, file) => acc + file.size, 0);

export default countTotalSize;
